// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-buttons {
  display: flex;
  gap: 10px; 
}
.table-responsive {
  width: 100%;
  overflow-x: auto;
}

mat-table {
  min-width: 1200px; /* Adjust as needed for your columns */
  width: max-content; /* Ensures table grows horizontally */
  display: table;     /* Fixes some flex issues */
}

/* Letter Equipment Table Header Styles */
th.mat-header-cell, th.text-center {
  font-family: 'Arial', 'Helvetica', sans-serif;
  font-size: 15px;
  font-weight: bold;
  text-transform: capitalize;
  color: #000;
  background: #f8f9fa;
  padding: 12px 8px;
}

/* Filter Input Styles */
.mat-input-element,
input[type="text"].mat-input-element,
input[type="search"].mat-input-element,
th .mat-input-element,
th input[type="text"].mat-input-element {
  font-family: 'Arial', 'Helvetica', sans-serif;
  font-size: 13.5px;
  font-weight: normal;
  font-style: italic;
  color: #b0b0b0;
  border-radius: 4px;
  border: 1px solid #ced4da;
  padding: 4px 8px;
  background: #fff;
  margin-top: 6px;
  margin-bottom: 4px;
  width: 100%;
  box-sizing: border-box;
}
.header-container {
  display: flex;
  align-items: center; 
  justify-content: center;
  gap: 2px; 
  width: 100%; 
  text-align: center;
}
 
.filter-container {
  margin-top: 5px; 
  text-align: center; 
}`, "",{"version":3,"sources":["webpack://./projects/tilmanagement/src/app/technical-letters/edit-technical-letters/edit-technical-letters.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,sCAAsC;EACzD,kBAAkB,EAAE,qCAAqC;EACzD,cAAc,MAAM,2BAA2B;AACjD;;AAEA,yCAAyC;AACzC;EACE,6CAA6C;EAC7C,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;;;;;EAKE,6CAA6C;EAC7C,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".action-buttons {\n  display: flex;\n  gap: 10px; \n}\n.table-responsive {\n  width: 100%;\n  overflow-x: auto;\n}\n\nmat-table {\n  min-width: 1200px; /* Adjust as needed for your columns */\n  width: max-content; /* Ensures table grows horizontally */\n  display: table;     /* Fixes some flex issues */\n}\n\n/* Letter Equipment Table Header Styles */\nth.mat-header-cell, th.text-center {\n  font-family: 'Arial', 'Helvetica', sans-serif;\n  font-size: 15px;\n  font-weight: bold;\n  text-transform: capitalize;\n  color: #000;\n  background: #f8f9fa;\n  padding: 12px 8px;\n}\n\n/* Filter Input Styles */\n.mat-input-element,\ninput[type=\"text\"].mat-input-element,\ninput[type=\"search\"].mat-input-element,\nth .mat-input-element,\nth input[type=\"text\"].mat-input-element {\n  font-family: 'Arial', 'Helvetica', sans-serif;\n  font-size: 13.5px;\n  font-weight: normal;\n  font-style: italic;\n  color: #b0b0b0;\n  border-radius: 4px;\n  border: 1px solid #ced4da;\n  padding: 4px 8px;\n  background: #fff;\n  margin-top: 6px;\n  margin-bottom: 4px;\n  width: 100%;\n  box-sizing: border-box;\n}\n.header-container {\n  display: flex;\n  align-items: center; \n  justify-content: center;\n  gap: 2px; \n  width: 100%; \n  text-align: center;\n}\n \n.filter-container {\n  margin-top: 5px; \n  text-align: center; \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
